module.exports = __webpack_public_path__ + "static/10400556_21579347223_8845_n-475d2daafa69a5846794ec457e8740b5.jpg";